module.exports = __webpack_public_path__ + "static/media/frog.ecc5cbbf.svg";